module.exports = ".dashboard{\r\n    display:flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.content{\r\n    display:block;\r\n    width: 100%;\r\n}"